// src/routes/skillsRoutes.jsx
import React from 'react';
import { Route } from 'react-router-dom';
import Skills from '../pages/skills/Skills';
import CreateSkill from '../pages/skills/CreateSkill';
import EditSkill from '../pages/skills/EditSkill';
import ProtectedRoute from '../components/global/ProtectedRoute';

const skillsRoutes = (
    <>
        {/* Skills List */}
        <Route
            path="/skills"
            element={
                <ProtectedRoute requiredPermission="viewAny-skill">
                    <Skills />
                </ProtectedRoute>
            }
        />

        {/* Create Skill */}
        <Route
            path="/skills/create"
            element={
                <ProtectedRoute requiredPermission="create-skill">
                    <CreateSkill />
                </ProtectedRoute>
            }
        />

        {/* Edit Skill */}
        <Route
            path="/skills/:id/edit"
            element={
                <ProtectedRoute requiredPermission="update-skill">
                    <EditSkill />
                </ProtectedRoute>
            }
        />
    </>
);

export default skillsRoutes;